import React, { useState } from 'react';
import {
  Box,
  TextField,
  Stack,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useGlobal } from '../../contexts/GlobalContext';

const ParamsPolymarketV1 = ({ onParamsChange }) => {
  const { defaultPolymarketWalletAddress } = useGlobal();
  const [currentTab, setCurrentTab] = useState('user');

  // User section
  const [wallet, setWallet] = useState(defaultPolymarketWalletAddress || '');

  // New Markets section
  const [newMarketsHours, setNewMarketsHours] = useState(24);
  const [newMarketsSize, setNewMarketsSize] = useState(5);

  // User Markets Bets section
  const [userMarketsBetsHours, setUserMarketsBetsHours] = useState(24);
  const [userMarketsBetsSize, setUserMarketsBetsSize] = useState(5);
  const [userMarketsBetsMinBetAmount, setUserMarketsBetsMinBetAmount] = useState(1000);

  // Relevant Markets Price Change section
  const [otherMarketsPriceChangeThreshold, setOtherMarketsPriceChangeThreshold] = useState(0.25);
  const [otherMarketsPriceChangeSize, setOtherMarketsPriceChangeSize] = useState(5);

  // Relevant Markets Bets section
  const [otherMarketsBetsHours, setOtherMarketsBetsHours] = useState(24);
  const [otherMarketsBetsSize, setOtherMarketsBetsSize] = useState(5);
  const [otherMarketsBetsMinBetAmount, setOtherMarketsBetsMinBetAmount] = useState(1000);

  // Update params whenever any input changes
  React.useEffect(() => {
    const params = {
      wallet,
      new_markets: {
        hours: parseInt(newMarketsHours),
        size: parseInt(newMarketsSize),
      },
      user_markets_bets: {
        hours: parseInt(userMarketsBetsHours),
        size: parseInt(userMarketsBetsSize),
        min_bet_amount: parseInt(userMarketsBetsMinBetAmount),
      },
      relevant_markets_bets: {
        hours: parseInt(otherMarketsBetsHours),
        size: parseInt(otherMarketsBetsSize),
        min_bet_amount: parseInt(otherMarketsBetsMinBetAmount),
      },
      relevant_markets_price_change: {
        threshold: parseFloat(otherMarketsPriceChangeThreshold),
        size: parseInt(otherMarketsPriceChangeSize),
      },
    };
    onParamsChange(params);
  }, [
    wallet,
    newMarketsHours,
    newMarketsSize,
    userMarketsBetsHours,
    userMarketsBetsSize,
    userMarketsBetsMinBetAmount,
    otherMarketsPriceChangeThreshold,
    otherMarketsPriceChangeSize,
    otherMarketsBetsHours,
    otherMarketsBetsSize,
    otherMarketsBetsMinBetAmount,
    onParamsChange,
  ]);

  const handleWalletChange = (e) => {
    setWallet(e.target.value);
  };

  const handleNewMarketsHoursChange = (e) => {
    setNewMarketsHours(e.target.value);
  };

  const handleNewMarketsSizeChange = (e) => {
    setNewMarketsSize(e.target.value);
  };

  const handleUserMarketsBetsHoursChange = (e) => {
    setUserMarketsBetsHours(e.target.value);
  };

  const handleUserMarketsBetsSizeChange = (e) => {
    setUserMarketsBetsSize(e.target.value);
  };

  const handleUserMarketsBetsMinBetAmountChange = (e) => {
    setUserMarketsBetsMinBetAmount(e.target.value);
  };

  const handleOtherMarketsPriceChangeThresholdChange = (e) => {
    setOtherMarketsPriceChangeThreshold(e.target.value);
  };

  const handleOtherMarketsPriceChangeSizeChange = (e) => {
    setOtherMarketsPriceChangeSize(e.target.value);
  };

  const handleOtherMarketsBetsHoursChange = (e) => {
    setOtherMarketsBetsHours(e.target.value);
  };

  const handleOtherMarketsBetsSizeChange = (e) => {
    setOtherMarketsBetsSize(e.target.value);
  };

  const handleOtherMarketsBetsMinBetAmountChange = (e) => {
    setOtherMarketsBetsMinBetAmount(e.target.value);
  };

  const handleTabChange = (event) => {
    setCurrentTab(event.target.value);
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case 'user':
        // User Section
        return (
          <Stack spacing={2}>
            <TextField
              label="Wallet Address"
              placeholder="Enter wallet address"
              value={wallet}
              onChange={handleWalletChange}
              fullWidth
              size="small"
              variant="outlined"
            />
          </Stack>
        );

      case 'new_markets':
        // New Markets Section
        return (
          <Stack spacing={2}>
            <TextField
              label="Hours"
              type="number"
              value={newMarketsHours}
              onChange={handleNewMarketsHoursChange}
              fullWidth
              size="small"
              variant="outlined"
            />
            <TextField
              label="Size"
              type="number"
              value={newMarketsSize}
              onChange={handleNewMarketsSizeChange}
              fullWidth
              size="small"
              variant="outlined"
            />
          </Stack>
        );

      case 'user_markets_bets':
        // User Markets Bets Section
        return (
          <Stack spacing={2}>
            <TextField
              label="Hours"
              type="number"
              value={userMarketsBetsHours}
              onChange={handleUserMarketsBetsHoursChange}
              fullWidth
              size="small"
              variant="outlined"
            />
            <TextField
              label="Size"
              type="number"
              value={userMarketsBetsSize}
              onChange={handleUserMarketsBetsSizeChange}
              fullWidth
              size="small"
              variant="outlined"
            />
            <TextField
              label="Min Bet Amount"
              type="number"
              value={userMarketsBetsMinBetAmount}
              onChange={handleUserMarketsBetsMinBetAmountChange}
              fullWidth
              size="small"
              variant="outlined"
            />
          </Stack>
        );

      case 'relevant_markets_bets':
        // Relevant Markets Bets Section
        return (
          <Stack spacing={2}>
            <TextField
              label="Hours"
              type="number"
              value={otherMarketsBetsHours}
              onChange={handleOtherMarketsBetsHoursChange}
              fullWidth
              size="small"
              variant="outlined"
            />
            <TextField
              label="Size"
              type="number"
              value={otherMarketsBetsSize}
              onChange={handleOtherMarketsBetsSizeChange}
              fullWidth
              size="small"
              variant="outlined"
            />
            <TextField
              label="Min Bet Amount"
              type="number"
              value={otherMarketsBetsMinBetAmount}
              onChange={handleOtherMarketsBetsMinBetAmountChange}
              fullWidth
              size="small"
              variant="outlined"
            />
          </Stack>
        );

      case 'relevant_markets_price_change':
        // Relevant Markets Price Change Section
        return (
          <Stack spacing={2}>
            <TextField
              label="Threshold"
              type="number"
              value={otherMarketsPriceChangeThreshold}
              onChange={handleOtherMarketsPriceChangeThresholdChange}
              fullWidth
              size="small"
              variant="outlined"
            />
            <TextField
              label="Size"
              type="number"
              value={otherMarketsPriceChangeSize}
              onChange={handleOtherMarketsPriceChangeSizeChange}
              fullWidth
              size="small"
              variant="outlined"
            />
          </Stack>
        );

      default:
        return null;
    }
  };

  const sectionOptions = [
    { value: 'user', label: 'User' },
    { value: 'new_markets', label: 'New Markets' },
    { value: 'user_markets_bets', label: 'User Markets / Significant Bets' },
    { value: 'relevant_markets_bets', label: 'Relevant Markets / Significant Bets' },
    { value: 'relevant_markets_price_change', label: 'Relevant Markets / Price Change' },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl fullWidth size="small">
        <InputLabel id="section-label">Section</InputLabel>
        <Select
          labelId="section-label"
          id="section-select"
          value={currentTab}
          onChange={handleTabChange}
          label="Section"
        >
          {sectionOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Paper sx={{ p: 2 }}>
        {renderTabContent()}
      </Paper>
    </Box>
  );
};

export default ParamsPolymarketV1;

